import { API_CONFIG } from '../config/api';

export const resolveDownloadUrl = (downloadUrl: string): string => {
  if (downloadUrl.startsWith('http://') || downloadUrl.startsWith('https://')) {
    return downloadUrl;
  }

  const base = API_CONFIG.BASE_URL.replace(/\/$/, '');
  const path = downloadUrl.startsWith('/') ? downloadUrl : `/${downloadUrl}`;
  return `${base}${path}`;
};

export const fetchAuthenticatedBlob = async (downloadUrl: string): Promise<Blob> => {
  const token = localStorage.getItem('token');
  const response = await fetch(resolveDownloadUrl(downloadUrl), {
    method: 'GET',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  if (!response.ok) {
    throw new Error('Failed to load file');
  }

  return response.blob();
};

export const fetchAuthenticatedObjectUrl = async (downloadUrl: string): Promise<string> => {
  const blob = await fetchAuthenticatedBlob(downloadUrl);
  return URL.createObjectURL(blob);
};

/** Opens an authenticated attachment in a new browser tab (PDF/images preview inline). */
export const openAuthenticatedAttachmentInNewTab = async (downloadUrl: string): Promise<void> => {
  const objectUrl = await fetchAuthenticatedObjectUrl(downloadUrl);
  const opened = window.open(objectUrl, '_blank', 'noopener,noreferrer');
  if (!opened) {
    revokeObjectUrl(objectUrl);
    throw new Error('Pop-up blocked. Allow pop-ups to view this file.');
  }
};

export const revokeObjectUrl = (objectUrl: string | null | undefined): void => {
  if (objectUrl?.startsWith('blob:')) {
    URL.revokeObjectURL(objectUrl);
  }
};
